import $ from 'jquery';
import Change from './Change';

const OFFSET = 115 + 35; // header height plus top offset of sidebars

export default class Sticky {
  constructor(element) {
    this.element = element;
    this.$element = $(element);
    this.register();
  }

  register() {
    Change.onChange(this.update.bind(this));
    Change.update();
  }

  update() {
    if (window.innerHeight - OFFSET > this.$element.height()) {
      this.$element.addClass('sticky');
    } else {
      this.$element.removeClass('sticky');
    }

    return this;
  }
}
